(function () {
  if (window.__sizeGuideInit) return;
  window.__sizeGuideInit = true;

  // Move all size-guide drawers to <body> so position:fixed escapes any
  // ancestor stacking context (e.g. sticky parent on product page).
  function relocateDrawers() {
    var drawers = document.querySelectorAll('.size-guide-drawer');
    for (var i = 0; i < drawers.length; i++) {
      var d = drawers[i];
      if (d.parentNode !== document.body) {
        document.body.appendChild(d);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateDrawers);
  } else {
    relocateDrawers();
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.hidden = false;
    // force reflow so the transition runs
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-guide-open');
    var panel = drawer.querySelector('.size-guide-drawer__panel');
    if (panel) {
      // delay focus until transition end to avoid layout jump
      setTimeout(function () {
        panel.focus();
      }, 50);
    }
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-guide-open');
    document.removeEventListener('keydown', onKeydown);

    var panel = drawer.querySelector('.size-guide-drawer__panel');
    var hideAfterTransition = function (e) {
      // Only react to the panel's transform transition
      if (e && e.target !== panel) return;
      if (e && e.propertyName !== 'transform') return;
      drawer.hidden = true;
      panel && panel.removeEventListener('transitionend', hideAfterTransition);
    };
    if (panel) {
      panel.addEventListener('transitionend', hideAfterTransition);
      // Safety fallback in case transitionend doesn't fire
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
          panel.removeEventListener('transitionend', hideAfterTransition);
        }
      }, 600);
    } else {
      drawer.hidden = true;
    }
    // restore focus to last trigger
    if (drawer.__lastTrigger && typeof drawer.__lastTrigger.focus === 'function') {
      drawer.__lastTrigger.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var openDrawerEl = document.querySelector('.size-guide-drawer.is-open');
      if (openDrawerEl) closeDrawer(openDrawerEl);
    }
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-size-guide-open]');
    if (openTrigger) {
      e.preventDefault();
      var id = openTrigger.getAttribute('data-size-guide-open');
      var drawer = document.getElementById(id);
      if (drawer) {
        drawer.__lastTrigger = openTrigger;
        openDrawer(drawer);
      }
      return;
    }

    var closeTrigger = e.target.closest('[data-size-guide-close]');
    if (closeTrigger) {
      e.preventDefault();
      var drawerToClose = closeTrigger.closest('.size-guide-drawer');
      if (drawerToClose) closeDrawer(drawerToClose);
    }
  });
})();
